import Checkbox from '../checkbox';
import clsx from 'clsx';
import style from './style.module.scss';

const CheckboxGroup = ({ name, label, required, options, errors }) => {
    const err = errors.filter((el) => el.field === name);

    return (
        <div className={style.block}>
            <label className={clsx(style.label, required && style.required)}>{label}</label>

            {options &&
                options.length > 0 &&
                options.map((option, index) => (
                    <Checkbox
                        key={index}
                        id={option.id}
                        name={option.name}
                        label={option.label}
                        value={option.value ?? ''}
                        required={false}
                        group={true}
                    />
                ))}

            {err && err.length > 0 && <div className={style.error}>{err[0].message}</div>}
        </div>
    );
};

export default CheckboxGroup;
